/* eslint-disable no-useless-catch */
import { setToken, getToken } from '../tokenStore';
// eslint-disable-next-line import/no-cycle
import { logOutUser } from './currentUserAction';
import { isTokenValid } from '../helpers';
import { navigate } from '../navigators/NavigationService';
import { baseUrl } from '../constants/baseUrl';

import { REFRESH_TOKEN_SUCCESS, RESET_STORE } from './types';

export const resetAll = () => async (dispatch) => {
  await dispatch({ type: RESET_STORE });
  return {};
};

export const getNewTokens = () => async (dispatch) => {
  try {
    await fetch(`${baseUrl}auth/access-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        refresh_token: await getToken(),
      }),
    }).then(async (response) => {
      let newToken = {};
      let body = {};

      switch (response.status) {
        case 200:
        case 201:
          body = await response.json();
          newToken = {
            accessToken: body.access_token,
            expiresIn: body.expires_in,
            now: new Date(),
          };
          setToken(body.refresh_token);
          await dispatch({ type: REFRESH_TOKEN_SUCCESS, payload: newToken });
          break;
        default:
          throw new Error();
      }
    });
  } catch (e) {
    dispatch(logOutUser())
      .then(() => navigate('Auth'))
      .then(() => dispatch(resetAll()));
  }
};

const getAccessToken = ({ dispatch, currentUser }) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const { token } = currentUser;
    const isValid = isTokenValid({ duration: token.expiresIn, date: token.now });
    if (isValid) {
      return token.accessToken;
    }
    dispatch({ type: 'INVALID_TOKEN' });
    return new Error('access token not valid');
  } catch (e) {
    throw e;
  }
};

export const fetchWithAccessToken = ({ url, method, body = {} }) => async (dispatch, getState) => {
  try {
    const state = getState();
    const accessToken = getAccessToken({ dispatch, currentUser: state.currentUser });
    const params = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    if (method !== 'GET' && method !== 'DELETE') {
      params.body = body;
    }
    return fetch(url, params);
  } catch (e) {
    throw e;
  }
};
